(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jc-contact"]) return;
  try {
    
  (() => {
    function initContact(root) {
      if (root.dataset.contactReady) return;
      root.dataset.contactReady = 'true';
      const form = root.querySelector('#JcContactForm');
      if (!form) return;
      const success = root.querySelector('[data-contact-success]');
      if (success) { success.focus(); return; }
      const message = form.querySelector('[name="contact[body]"]');
      const counter = form.querySelector('[data-contact-counter]');
      const whatsapp = form.querySelector('[data-contact-whatsapp]');
      const requiredText = [...form.querySelectorAll('input[required]:not([type="checkbox"]), textarea[required]')];
      function update() {
        requiredText.forEach(field => field.setCustomValidity(field.value.trim() ? '' : 'Complete este campo para continuar.'));
        counter.textContent = `${message.value.length.toLocaleString('es')} / 1.500 caracteres`;
      }
      function valid() { update(); return form.reportValidity(); }
      form.addEventListener('input', update);
      form.addEventListener('submit', event => { if (!valid()) event.preventDefault(); });
      whatsapp.addEventListener('click', event => {
        if (!valid()) { event.preventDefault(); return; }
        const value = name => form.elements.namedItem(name).value.trim();
        const phone = value('contact[phone]');
        const text = [
          'Hola, Juan Carlos. Me gustaría consultar sobre mi planta.',
          `Nombre: ${value('contact[name]')}`,
          `Correo: ${value('contact[email]')}`,
          ...(phone ? [`Teléfono / WhatsApp: ${phone}`] : []),
          '',
          value('contact[body]')
        ].join('\n');
        whatsapp.href = `https://wa.me/573103432605?text=${encodeURIComponent(text)}`;
      });
      update();
    }
    document.querySelectorAll('[data-jc-contact]').forEach(initContact);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-jc-contact]').forEach(initContact));
  })();

  } catch(e) { console.error(e); }
})();
})();
